import { cn } from "../lib/utils"

// Define button variants
const buttonVariants = {
  default: {
    bgColor: "bg-brand hover:bg-brand/90",
    width: "w-auto",
    rounded: "rounded-lg",
    padding: "px-4 py-2.5",
    textTransform: "uppercase",
    className: "text-white",
  },
  secondary: {
    bgColor: "bg-brandSecondary hover:bg-brandSecondary/90",
    width: "w-fit",
    rounded: "rounded-full",
    padding: "px-6 py-4",
    textTransform: "normal-case",
    className: "text-white",
  },
  "secondary-outline": {
    bgColor: "bg-transparent",
    width: "w-fit",
    rounded: "rounded-full",
    padding: "px-6 py-4",
    textTransform: "normal-case",
    className: "border border-brandSecondary text-brandSecondary cursor-pointer",
  },
  "secondary-ghost": {
    bgColor: "bg-transparent",
    width: "w-fit",
    rounded: "rounded-full",
    padding: "px-6 py-4",
    textTransform: "normal-case",
    className: "text-brandSecondary cursor-pointer hover:text-brandSecondary/80 disabled:text-gray-400 disabled:cursor-default",
  },
  waiting: {
    bgColor: "bg-yellow-400/80 hover:bg-yellow-400",
    width: "w-auto",
    rounded: "rounded-full",
    padding: "px-6 py-4",
    textTransform: "normal-case",
    className: "text-black border border-black",
  },
  locked: {
    bgColor: "bg-gray-100 cursor-not-allowed",
    width: "w-auto",
    rounded: "rounded-full",
    padding: "px-6 py-4",
    textTransform: "normal-case",
    className: "border border-gray-400 text-gray-400",
  },
  success: {
    bgColor: "bg-white",
    width: "w-auto",
    rounded: "rounded-full",
    padding: "px-6 py-4",
    textTransform: "normal-case",
    className: "border border-green-500 text-green-500",
  },
  "gray-ghost": {
    bgColor: "bg-transparent",
    width: "w-auto",
    rounded: "rounded-full",
    padding: "px-6 py-4",
    textTransform: "normal-case",
    className: "text-gray-400 hover:text-gray-500 disabled:text-gray-400 disabled:cursor-default",
  }
}

const Button = props => {
  const {
    variant,
    className,
    beforeIcon,
    bgColor: propBgColor,
    width: propWidth,
    rounded: propRounded,
    padding: propPadding,
    textTransform: propTextTransform,
    ...restProps
  } = props

  // Get variant styles if variant is specified
  const variantStyles = variant ? buttonVariants[variant] : {}

  // Apply individual props with fallback to variant, then to defaults
  const bgColor = propBgColor || variantStyles?.bgColor || buttonVariants.default.bgColor
  const width = propWidth || variantStyles?.width || buttonVariants.default.width
  const rounded = propRounded || variantStyles?.rounded || buttonVariants.default.rounded
  const padding = propPadding || variantStyles?.padding || buttonVariants.default.padding
  const textTransform =
    propTextTransform || variantStyles?.textTransform || buttonVariants.default.textTransform
  const otherStyles = variantStyles?.className || "text-white items-center flex flex-row gap-2"

  return (
    <button
      className={cn(
        "relative font-bold",
        "disabled:opacity-70 disabled:pointer-events-none",
        bgColor,
        width,
        rounded,
        padding,
        textTransform,
        otherStyles,
        className,
      )}
      {...restProps}
    >
      {(variant === "success" || variant === "locked" || variant === "waiting") && (
        <span className={"absolute left-8 top-1/2 -translate-y-1/2"}>
          {variant === "success" && <i className="fa-solid fa-circle-check -ml-6 text-4xl"></i>}
          {variant === "locked" && <i className="fa-solid fa-lock"></i>}
          {variant === "waiting" && <i className="fa-regular fa-clock"></i>}
        </span>
      )}
      {beforeIcon && <span className="mr-2">{beforeIcon}</span>}
      {props.children}
    </button>
  )
}

export default Button
